import {
  Grid,
  Theme,
  Typography,
  WithStyles,
  withStyles
} from '@material-ui/core'
import { FC } from 'react'
import { WithTranslation, withTranslation } from 'react-i18next'
import { connect } from 'react-redux'
import { Dispatch } from 'redux'
import { confirmPasswordReset } from '../../../../actions/users'
import ChangeLanguageForm from '../../../../components/ChangeLanguageForm'
import { MuiClasses } from '../../../../types'
import { bindSubmitActionToPromise } from '../../../../utils/forms'
import ConfirmPasswordResetForm from './ConfirmPasswordResetForm'

const styles = ({ spacing }: Theme) => ({
  form: {
    padding: spacing(),
    maxWidth: 600,
    margin: '50px auto'
  }
})

type ParamsProps = {
  email: string
  code: string
}

interface MatchProps {
  params: ParamsProps
}

interface ConfirmPasswordResetProps extends WithTranslation, WithStyles {
  classes: MuiClasses
  doConfirmPasswordReset: (arg: any) => any
  isPasswordResetConfirmed: boolean
  email: string
  match: MatchProps
}

const ConfirmPasswordReset: FC<ConfirmPasswordResetProps> = ({
  classes,
  t,
  doConfirmPasswordReset,
  isPasswordResetConfirmed,
  // react-router and connected-react-router handling for picking email from component props
  match: {
    params: { email, code }
  }
}) => (
  <Grid
    container
    direction='column'
    alignItems='center'
    className={classes.form}
  >
    <Typography variant='h3' gutterBottom>
      {t('forgotPassword.title')}
    </Typography>
    <ConfirmPasswordResetForm
      confirmReset={doConfirmPasswordReset}
      t={t}
      initialValues={{ email, verificationCode: code }}
    />
    {isPasswordResetConfirmed && (
      <Typography variant='body2' gutterBottom>
        {t('forgotPassword.success')}
      </Typography>
    )}
    <ChangeLanguageForm />
  </Grid>
)

const mapDispatchToProps = (dispatch: Dispatch) => ({
  doConfirmPasswordReset: bindSubmitActionToPromise(
    dispatch,
    confirmPasswordReset
  )
})

export default connect(
  null,
  mapDispatchToProps
)(
  withStyles(styles)(
    withTranslation()(ConfirmPasswordReset as any) as any
  ) as any
)
